import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Reroute = () => {
  const project = useSelector((state) => state.data.project);
  const navigate = useNavigate();

  useEffect(() => {
    if (project?.title) {
      navigate(`/projects/${project?.projectId}/info`);
    } else if (project?.ideaMaps) {
      navigate(
        `/projects/${project?.projectId}/ideaMaps/${project?.ideaMaps?.[0]?.ideaMapId}`
      );
    } else if (project?.surveys) {
      navigate(
        `/projects/${project?.projectId}/survey/${project?.surveys?.[0]?.surveyId}`
      );
      // navigate(`/projects/${project?.projectId}/info`);
    }
  }, [project?.title]);

  return <div>Reroute</div>;
};

export default Reroute;
